import type { Level } from '@/warranty/domain/repositories/warranty.repository';

export interface LevelRow {
  'onboarding_level_info.accure_level': string;
  'onboarding_level_info.customer_level_name': string;
}

export function transformLevelRow(result: LevelRow): Level {
  return {
    accureName: result['onboarding_level_info.accure_level'],
    customerName: result['onboarding_level_info.customer_level_name'],
  };
}
